import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35699993"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-statistice-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "设备统计", -1))
const _hoisted_3 = { class: "bar" }
const _hoisted_4 = { class: "bar-info ws_ml45" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "设备状态", -1))
const _hoisted_7 = { class: "device-status ws_mt35" }

import { ref, nextTick } from 'vue'
import * as echarts from 'echarts'
import { set } from 'lodash'
import StatusPieChart from './status-pie-chart.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-statistics',
  setup(__props, { expose: __expose }) {

const chartRef = ref()

const list: any = ref([
  {
    name: '单模网关',
    value: '',
    unit: '台',
    class: 'danmo',
    key: 'singleModeDeviceTotal',
  },
  {
    name: '多模网关',
    value: '',
    unit: '台',
    class: 'duomo',
    key: 'multiModeDeviceTotal',
  },
  {
    name: 'Lora设备',
    value: '',
    unit: '台',
    class: 'lora',
    key: 'loraDeviceTotal',
  },
])

const chartOps = {
  tooltip: {
    trigger: 'item',
  },
  series: [
    {
      data: [50],
      type: 'pie',
      radius: ['55%', '95%'],
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
      },
      emphasis: {
        label: {
          show: false,
          fontSize: 40,
          fontWeight: 'bold',
        },
      },
      labelLine: {
        show: false,
      },
      color: ['#5B8FF9', '#61DDAA', '#ff9626'],
    },
  ],
}

const statusPieConf = ref([
  {
    label: '在线设备',
    num: 0,
    percent: 0,
    key: 'onlineDeviceTotal',
    percentKey: 'onlineDeviceRate',
    color: '#548DE3',
  },
  {
    label: '离线设备',
    num: 0,
    percent: 0,
    key: 'offlineDeviceTotal',
    percentKey: 'offlineDeviceRate',
    color: '#E35454',
  },
  {
    label: '待激活设备',
    num: 0,
    percent: 0,
    key: 'noActiveDeviceTotal',
    percentKey: 'noActiveDeviceRate',
    color: '#9BE354',
  },
])

const pieRefList: any = ref([])
const getPieRef = (el: any, index: number) => {
  if (el) {
    pieRefList.value[index] = el
  }
}

const init = (data: any) => {
  const moList = list.value.map((item: any) => {
    return {
      ...item,
      value: data[item.key] || 0,
    }
  })
  list.value = moList
  set(chartOps, 'series[0].data', moList)

  const myChart = echarts.init(chartRef.value)
  myChart.setOption(chartOps)

  statusPieConf.value = statusPieConf.value.map((item: any) => {
    const num = data[item.key] || 0
    const otherNum = data.deviceTotal - num

    return {
      ...item,
      percent: data[item.percentKey] || 0,
      num,
      otherNum,
    }
  })

  nextTick(() => {
    pieRefList.value.map((refItem: any) => {
      refItem.init()
    })
  })
}

__expose({
  init,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        ref_key: "chartRef",
        ref: chartRef,
        class: "bar-conatiner"
      }, null, 512),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("p", { key: index }, [
            _createElementVNode("span", {
              class: _normalizeClass(["label", item.class])
            }, _toDisplayString(item.name), 3),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.value) + _toDisplayString(item.unit), 1)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusPieConf.value, (item, index) => {
        return (_openBlock(), _createBlock(StatusPieChart, {
          key: index,
          data: item,
          ref_for: true,
          ref: (el) => getPieRef(el, index)
        }, null, 8, ["data"]))
      }), 128))
    ])
  ]))
}
}

})